import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

export const ResponsibilityHandoverForm_Replacements_Query = graphql(`
  query ResponsibilityHandoverForm_Replacements($statusId: Id!) {
    findSomePeople(filter: { statusId: $statusId, isInternal: true }) {
      _id
      fullName
      firstName
      lastName
    }
  }
`);

export const useHandoverReplacementsQuery = (enabled: boolean) => {
  const { genericStatusesCodeMap } = useReferencesContext();

  return useGraphQLQuery(
    ResponsibilityHandoverForm_Replacements_Query,
    { statusId: genericStatusesCodeMap.Enabled._id },
    { enabled },
  );
};
